export * from './iacademic-year.interface';
export * from './icommit-reschedule.interface';
export * from './icore-course-catalog.interface';
export * from './icore-grade-scale.interface';
export * from './igrade-report-column.interface';
export * from './icore-lesson-type.interface';
export * from './icore-program.interface';
export * from './icourse-objective.interface';
export * from './igrading-template.interface';
export * from './ihomework-category.interface';
export * from './ilanguage.interface';
export * from './ireschedule-check.interface';
export * from './ireschedule-options.interface';
export * from './ischedule-preview.interface';
export * from './ischedule-request.interface';
export * from './ischedule-result.interface';
